import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./HomeSections.css";

const TakeFreeDemo = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email: email,
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )
      .then(
        () => {
          setMessage("Demo request submitted successfully!");
          setEmail("");
        },
        () => {
          setMessage("Failed to send email. Try again.");
        },
      );
  };

  return (
    <section className="free-demo-section">
      <div className="free-demo-container">
        <h2>Take the First Step Towards Career Clarity!</h2>

        <div className="demo-form">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button onClick={handleSubmit}>Take Free Demo</button>
        </div>

        {message && <p>{message}</p>}
      </div>
    </section>
  );
};

export default TakeFreeDemo;
